import { render, staticRenderFns } from "./appColorPicker.vue?vue&type=template&id=633de0c5"
import script from "./appColorPicker.vue?vue&type=script&lang=js"
export * from "./appColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports